/* global axios */
import ApiClient from './ApiClient';

// d99d Endpoints for the concurrent users feature.
class ConcurrentUsersAPI extends ApiClient {
  constructor() {
    // Will result in `/api/v1/accounts/:account_id/concurrent_users`.
    super('concurrent_users', { accountScoped: true });
  }

  // Answers with { count, limit, page, users }, 10 users per page.
  get(page = 1) {
    return axios.get(this.url, { params: { page } });
  }
}

export default new ConcurrentUsersAPI();
